function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-180 4.559 8)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4.941,
  height: 1.412,
  rx: 0.706
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.941.706v10.588a.706.706 0 1 1-1.412 0V.706a.706.706 0 1 1 1.412 0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.941,
  height: 1.412,
  y: 10.588,
  rx: 0.706
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.941 9.294H16a.706.706 0 0 1 0 1.412H8.941a.706.706 0 0 1 0-1.412z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.237 6.238l2.995 2.995a.706.706 0 0 1-.999.999L12.24 7.236a.706.706 0 0 1 .998-.998z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.238 12.762l2.996-2.994a.706.706 0 0 1 .998.998l-2.995 2.994a.706.706 0 0 1-.999-.998z"
})));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.8c93c254.svg";
export { ForwardRef as ReactComponent };